/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DriversMenuRow,
    DriversMenuRowFromJSON,
    DriversMenuRowFromJSONTyped,
    DriversMenuRowToJSON,
} from './';

/**
 * 乗務員リストメニュー
 * @export
 * @interface DriversMenuList
 */
export interface DriversMenuList {
    /**
     * 
     * @type {Array<DriversMenuRow>}
     * @memberof DriversMenuList
     */
    drivers?: Array<DriversMenuRow>;
}

export function DriversMenuListFromJSON(json: any): DriversMenuList {
    return DriversMenuListFromJSONTyped(json, false);
}

export function DriversMenuListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriversMenuList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'drivers': !exists(json, 'drivers') ? undefined : ((json['drivers'] as Array<any>).map(DriversMenuRowFromJSON)),
    };
}

export function DriversMenuListToJSON(value?: DriversMenuList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'drivers': value.drivers === undefined ? undefined : ((value.drivers as Array<any>).map(DriversMenuRowToJSON)),
    };
}


